const keyValueMapper = (array, key, value) => {
    return array.reduce((acc, cur) => {
      acc[cur[key]] = cur[value];
      return acc;
    }, {});
  };
  
  export default keyValueMapper;
  export { keyValueMapper };
  